import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import Link from 'next/link';
import Button from '../Button';
import { getLenderImage } from '../../utils/index';
import styles from './styles';
import CImageComponent from '../CImageComponent';

export interface LenderCardProps {
  deals: {
    initialPayRate: string;
    mortgageClass: string;
    initialRatePeriodMonths: string;
    standardVariableRate: string;
    aprLenders: string;
    lenderName: string;
    lenderCode: string;
  };
  onClick: (lender: any) => void;
}

function LenderCard({ onClick, deals }: LenderCardProps) {
  return (
    <>
      {deals?.map((item, index) => (
        <Grid container sx={styles.container} key={index}>
          <Grid item md={5} sx={styles.imageContainer}>
            <Box sx={styles.imageBox}>
              <CImageComponent
                src={getLenderImage(item?.lenderName, item?.lenderCode)}
                sizes="100vw"
                alt={item?.lenderName}
                width={0}
                height={0}
                style={styles.image}
              />
            </Box>
          </Grid>
          <Grid item md={7} sx={styles.contentContainerWrapper}>
            <Box>
              <Box sx={styles.contentContainer}>
                <Box flex={1}>
                  <Typography sx={styles.title}>Initial rate:</Typography>
                  <Typography sx={styles.content}>
                    {item?.initialPayRate}%
                  </Typography>
                </Box>
                <Box flex={1}>
                  <Typography sx={styles.title}>Type:</Typography>
                  <Typography sx={styles.content}>
                    {item?.mortgageClass}
                  </Typography>
                </Box>
              </Box>
              <Box sx={styles.contentContainer}>
                <Box flex={1}>
                  <Typography sx={styles.title}>Duration:</Typography>
                  <Typography sx={styles.content}>
                    For {item?.initialRatePeriodMonths} months
                  </Typography>
                </Box>
                <Box flex={1}>
                  <Typography sx={styles.title}>Reverting to:</Typography>
                  <Typography sx={styles.content}>
                    {item?.standardVariableRate} variable
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography sx={styles.title}>
                  The overall cost for comparison is:
                </Typography>
                <Typography sx={styles.content}>
                  {item?.aprLenders}% APR
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={12} sx={styles.buttonContainer}>
            <Button
              variant="secondary"
              fullWidth
              onClick={() => {
                document.body
                  .getElementsByClassName('MuiDrawer-paperAnchorRight')?.[0]
                  ?.scrollTo({ top: 0 });
                onClick(item);
              }}
            >
              Calculate
            </Button>
          </Grid>
        </Grid>
      ))}
      <Box mb={2} sx={{ width: '100%' }}>
        <Link prefetch={false} href="https://www.alexanderhall.co.uk/contact">
          <Button variant="tertiary">Need help choosing a mortgage?</Button>
        </Link>
      </Box>
    </>
  );
}

export default LenderCard;
